<template>
  <b-card class="mt-2">
    <template #header>
      <div class="row justify-content-between">
        <div class="col-auto">
          Filtro
          <b-badge variant="success" class="mr-2">{{ labelHeader }}</b-badge>
        </div>
      </div>
    </template>
    <div>
      <b-form @submit="onSubmit" class="row">
        <div v-for="input in fieldsInput" :key="input" :class="input.class">
          <b-form-group v-if="input.type == 'text'" :label="input.label">
            <b-form-input
              v-model="input.value"
              :required="input.required"
            ></b-form-input>
          </b-form-group>

          <b-form-group v-if="input.type == 'number'" :label="input.label">
            <b-form-input
              type="number"
              v-model="input.value"
              :required="input.required"
            ></b-form-input>
          </b-form-group>
          <b-form-group v-if="input.type == 'switch'" :label="input.label">
            <InputSwitch
              v-model="input.value"
              :trueValue="true"
              :falseValue="false"
            />
          </b-form-group>

          <b-form-group v-if="input.type == 'date'" :label="input.label">
            <PrimeCalendar
              v-model="input.value"
              selectionMode="single"
              dateFormat="dd/mm/yy"
              showIcon
            />
          </b-form-group>
          <b-form-group v-if="input.type == 'combo'" :label="input.label">
            <ComboDefault
              :slug="input.slug"
              :slugId="input.slugId"
              :slugDesc="input.slugDesc"
              :endpoint="input.endpoint"
              :required="input.required"
              v-model="input.value"
              @onChangeCombo="
                (value) => {
                  input.value = value
                }
              "
            />
          </b-form-group>
          <b-form-group v-if="input.type == 'multiselect'" :label="input.label">
            <VueMultiselect
              @change="
                (value) => {
                  form[input.slug] = value
                }
              "
              mode="tags"
              v-model="input.value"
              :options="input.optionsCombo"
              noOptionsText="Nenhum resultado encontrado!"
              noResultsText="Nenhum resultado encontrado!"
              placeholder=""
              :searchable="true"
            >
            </VueMultiselect>
          </b-form-group>
        </div>
        <div class="d-flex justify-content-between">
          <b-button class="clear-filter bg-secondary" @click="clearFilter">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-eraser"
              viewBox="0 0 16 16"
            >
              <path
                d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"
              />
            </svg>
          </b-button>
          <b-button class="submit-filter" type="submit">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path
                d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"
              />
            </svg>
          </b-button>
        </div>
      </b-form>
    </div>
  </b-card>
</template>

<script>
import { onMounted, ref } from 'vue'
import router from '@/router'
export default {
  props: {
    fieldsInput: Array,
    table: String,
    labelHeader: String,
    item: Object,
  },
  setup() {
    const breadcrumbs = ref()
    const getBreadcrumbs = () => {
      return router.currentRoute.value.matched.map((route) => {
        return {
          active: route.path === router.currentRoute.value.fullPath,
          name: route.name,
          hasActions: route.props.default.hasActions,
          path: `${router.options.history.base}${route.path}`,
        }
      })
    }
    router.afterEach(() => {
      breadcrumbs.value = getBreadcrumbs()
    })
    onMounted(() => {
      breadcrumbs.value = getBreadcrumbs()
    })

    return {
      breadcrumbs,
    }
  },
  data() {
    return {
      form: this.item ?? {},
    }
  },
  created() {
    /* if (!this.fieldsInput) {
      this.fieldsInput = this.$store.getters['filtros'].value[this.$route.path]
    } else {
      this.fieldsInput = this.fieldsInput
    } */
  },
  methods: {
    setInputs() {
      this.form = {}
      this.fieldsInput.forEach((field) => {
        this.form[field.slug] = field.value
      })
    },
    async onSubmit(event) {
      this.setInputs()
      this.emitter.emit('update-filter', [event, this.form])
    },
    clearFilter() {
      this.fieldsInput.forEach((field) => {
        field.value = null
      })
    },
  },
  watch: {
    /* $route: {
      deep: true,
      handler: function () {
        if (!this.fieldsInput) {
          this.fieldsInput =
            this.$store.getters['filtros'].value[this.$route.path]
        } else {
          this.fieldsInput = this.fieldsInput
        }
      },
    }, */
  },
}
</script>
<style scoped>
.clear-filter {
  width: 49%;
}
.submit-filter {
  background-color: #07a302;
  border-color: #07a302;
  width: 49%;
}
</style>
